import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, includes, map } from 'lodash';
import { Form } from 'react-bootstrap';

import { LAYER_SUBTYPES, GEOREF_TYPES, LAYER_TYPES } from '../../../api/Layers/Layers';

const LayerGeorefTypeField = ({
  georefType,
  layerSubType,
  layerType,
  changeLayerEditorStateProperty
}) => {
  const possibleGeorefTypes = cloneDeep(GEOREF_TYPES.properties);
  if (LAYER_SUBTYPES.FIWARE === layerSubType) delete possibleGeorefTypes.H3;
  if (LAYER_SUBTYPES.FIWARE !== layerSubType) delete possibleGeorefTypes.LOCATION;
  if (LAYER_SUBTYPES.FIWARE !== layerSubType) delete possibleGeorefTypes.ADDRESS;

  const selectGeorefType = event => {
    changeLayerEditorStateProperty('geojsonLoaded', false);
    changeLayerEditorStateProperty('georefType', event.target.value);
  };

  if (
    layerType !== LAYER_TYPES.SPATIAL ||
    !includes(
      [
        LAYER_SUBTYPES.CSV,
        LAYER_SUBTYPES.EXCEL,
        LAYER_SUBTYPES.FIWARE,
        LAYER_SUBTYPES.GOOGLE_SHEETS
      ],
      layerSubType
    )
  )
    return '';
  return (
    <Form.Group>
      <Form.Label>Georeferencing Type</Form.Label>
      <Form.Control as="select" name="georefType" value={georefType} onChange={selectGeorefType}>
        <option value="">-</option>
        {map(possibleGeorefTypes, ({ name, value, humanValue }) => {
          return (
            <option value={value} key={name}>
              {humanValue}
            </option>
          );
        })}
      </Form.Control>
    </Form.Group>
  );
};

LayerGeorefTypeField.propTypes = {
  georefType: PropTypes.string.isRequired,
  layerSubType: PropTypes.string.isRequired,
  layerType: PropTypes.string.isRequired,
  changeLayerEditorStateProperty: PropTypes.func.isRequired
};

export default LayerGeorefTypeField;
